// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import classnames from '@ta/common.classnames';
import Localize from '@ta/platform.i18n';
import styles from './ReportVoteError.css';

const ReportVoteError = () => (
  <div className={classnames(styles.iapTYContent, styles.iapTYText)}>
    <Localize id="social_report_prof_err" />{' '}
    {/* Oh dear! Something went wrong. Perhaps refresh and try again. */}
  </div>
);

export default ReportVoteError;
